export const ON = {
    invalidateQuery: 'invalidateQuery',
    actionResponse: 'actionResponse',
    devicePaired: 'devicePaired',
    deviceUnpaired: 'deviceUnpaired'
};
